import { isPossiblePhoneNumber } from 'libphonenumber-js';

export const isPhoneNumberValid = (candidate: string): boolean => {
  return isPossiblePhoneNumber(candidate, {
    defaultCountry: 'FR',
  });
};
